import React, { useState, useEffect } from "react";
import {
  Input,
  Row,
  Col,
  Radio,
  Divider,
  DatePicker,
  Space,
  Checkbox,
  Select,
  Tooltip,
} from "antd";
import { getCommaSeparatedTwoDecimalsNumber } from "../../stores/utils/formatNumber";
import { IoInformationCircleSharp } from "react-icons/io5";
import { colorScheme } from "../../contants/variables";
import "./carform.scss";

const FieldSuffix = (props) => {
  const { TooltipData } = props;
  return (
    <Tooltip
      title={() => {
        return <TooltipData />;
      }}
      placement="bottomRight"
    >
      <IoInformationCircleSharp
        color={colorScheme.primary}
        style={{ fontSize: "20px" }}
      />
    </Tooltip>
  );
};

const Specifications = (props) => {
  const { form, specifications, setForm, isEdit, fuelTypes } = props;

  const handleFieldChange = (name, e, label, type) => {
    setForm({
      ...form,
      specifications: {
        ...specifications,
        [name]: { label: label, value: e.target.value, type: type },
      },
    });
  };

  const handleDropdownChange = (name, value, label, type) => {
    setForm({
      ...form,
      specifications: {
        ...specifications,
        [name]: { label: label, value: value, type: type },
      },
    });
  };

  const handleNumberFieldChange = (name, value, label, type, maxLength = 5) => {
    const numericValue = value.replace(/\D/g, "");

    if (numericValue.length <= maxLength) {
      setForm({
        ...form,
        specifications: {
          ...specifications,
          [name]: { label: label, value: numericValue, type: type },
        },
      });
    }
  };

  return (
    <div>
      <div className="sub-header-title">
        <p className="header">TRANSMISSION</p>
      </div>

      <Row>
        {/* <Col span={8}>
                    <div className="form-fields">
                    <p className="form-field-label">
                        Transmission :
                    </p>
                    <Select
                        showSearch
                        value={specifications?.transmission?.value || null}
                        onChange={(value) => handleDropdownChange("transmission", value, "Transmission", 'transmission')}
                        style={{ width: "100%" }}
                        placeholder="Search to Select."
                    >
                        <Select.Option value={"Automatic"}>Automatic</Select.Option>
                        <Select.Option value={"Manual"}>Manual</Select.Option>
                    </Select>
                    </div>
                </Col> */}
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">Number of Gears :</p>
            <Select
              value={specifications?.numberOfGears?.value || null}
              onChange={(value) =>
                handleDropdownChange(
                  "numberOfGears",
                  value,
                  "Number of Gears",
                  "transmission",
                )
              }
              style={{ width: "100%" }}
              placeholder="Search to Select."
            >
              <Select.Option value={4}>4</Select.Option>
              <Select.Option value={5}>5</Select.Option>
              <Select.Option value={6}>6</Select.Option>
              <Select.Option value={7}>7</Select.Option>
              <Select.Option value={8}>8</Select.Option>
              <Select.Option value={9}>9</Select.Option>
              <Select.Option value={10}>10</Select.Option>
            </Select>
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label"> Final Drive Ratio :</p>
              <FieldSuffix
                TooltipData={() => (
                  <p style={{ fontSize: "9px" }}>
                    {" "}
                    Final Drive Ratio eg: 4.999{" "}
                  </p>
                )}
              />
            </div>
            <Input
              value={specifications?.finalDriveRatio?.value ?? null}
              onChange={(e) => {
                handleNumberFieldChange(
                  "finalDriveRatio",
                  e.target.value,
                  "Final Drive Ratio",
                  "transmission",
                  5,
                );
              }}
              type="number"
            />
          </div>
        </Col>
      </Row>

      <Divider />

      <div className="sub-header-title">
        <p className="header">GENERAL</p>
      </div>

      <Row>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label"> Doors : </p>
            <Select
              showSearch
              value={specifications?.numberOfDoors?.value || null}
              onChange={(value) =>
                handleDropdownChange(
                  "numberOfDoors",
                  value,
                  "Doors",
                  "general",
                  "specifications",
                )
              }
              style={{ width: "100%" }}
              placeholder="Search to Select."
            >
              <Select.Option value={2}>2</Select.Option>
              <Select.Option value={3}>3</Select.Option>
              <Select.Option value={4}>4</Select.Option>
              <Select.Option value={5}>5</Select.Option>
              <Select.Option value={6}>6</Select.Option>
            </Select>
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label"> Seat Capacity : </p>
            <Select
              value={specifications?.seatCapacity?.value || null}
              onChange={(value) =>
                handleDropdownChange(
                  "seatCapacity",
                  value,
                  "Seat Capacity",
                  "general",
                  "specifications",
                )
              }
              style={{ width: "100%" }}
              placeholder="Search to Select."
            >
              <Select.Option value={2}>2</Select.Option>
              <Select.Option value={3}>3</Select.Option>
              <Select.Option value={4}>4</Select.Option>
              <Select.Option value={5}>5</Select.Option>
              <Select.Option value={6}>6</Select.Option>
              <Select.Option value={7}>7</Select.Option>
              <Select.Option value={8}>8</Select.Option>
              <Select.Option value={9}>9</Select.Option>
              <Select.Option value={10}>10</Select.Option>
            </Select>
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label"> Assembled : </p>
            <Select
              value={specifications?.assembled?.value || null}
              onChange={(value) =>
                handleDropdownChange(
                  "assembled",
                  value,
                  "Assembled",
                  "general",
                  "specifications",
                )
              }
              style={{ width: "100%" }}
              placeholder="Search to Select."
            >
              <Select.Option value={"Locally Built"}>
                Locally Built
              </Select.Option>
              <Select.Option value={"Oversea Built"}>
                Oversea Built
              </Select.Option>
            </Select>
          </div>
        </Col>
      </Row>

      <Divider />

      <div className="sub-header-title">
        <p className="header">ENGINE</p>
      </div>

      <Row>
        {/* <Col span={8}>
                    <div className="form-fields">
                    <div className="label-with-tooltip">
                        <p className="form-field-label"> Engine CC :</p>
                        <FieldSuffix
                            TooltipData={() => (
                            <p style={{ fontSize: "9px" }}> Engine CC input value min 100 to max 9999. </p>
                            )}
                        />
                    </div>
                    <Input
                        type="number"
                        value={specifications?.engineCap?.value}
                        onChange={(e) => { handleNumberFieldChange( "engineCap", e.target.value, 'Engine CC', 'engine', 5) }}
                        suffix={
                        <div className="fieldPrefix">
                            <p>CC</p>
                        </div>
                        }
                    />
                    </div>
                </Col> */}
        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label"> Bore :</p>
              <FieldSuffix
                TooltipData={() => (
                  <p style={{ fontSize: "9px" }}>
                    {" "}
                    Bore input value is max 9999.{" "}
                  </p>
                )}
              />
            </div>
            <Input
              type="number"
              value={specifications?.bore?.value}
              onChange={(e) => {
                handleNumberFieldChange(
                  "bore",
                  e.target.value,
                  "Bore",
                  "engine",
                  5,
                );
              }}
              suffix={
                <div className="fieldPrefix">
                  <p>mm</p>
                </div>
              }
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label"> Stroke :</p>
              <FieldSuffix
                TooltipData={() => (
                  <p style={{ fontSize: "9px" }}>
                    {" "}
                    Stroke input value is max 9999.{" "}
                  </p>
                )}
              />
            </div>
            <Input
              type="number"
              value={specifications?.stroke?.value}
              onChange={(e) => {
                handleNumberFieldChange(
                  "stroke",
                  e.target.value,
                  "Stroke",
                  "engine",
                  5,
                );
              }}
              suffix={
                <div className="fieldPrefix">
                  <p>mm</p>
                </div>
              }
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label"> Compression Ratio :</p>
              <FieldSuffix
                TooltipData={() => (
                  <p style={{ fontSize: "9px" }}>
                    {" "}
                    Compression Ratio input value is max 9999.{" "}
                  </p>
                )}
              />
            </div>
            <Input
              type="number"
              value={specifications?.compressionRatio?.value}
              onChange={(e) => {
                handleNumberFieldChange(
                  "compressionRatio",
                  e.target.value,
                  "Compression Ratio",
                  "engine",
                  5,
                );
              }}
            />
          </div>
        </Col>
        {/* <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label"> Peak Power :</p>
              <FieldSuffix
                TooltipData={() => (
                  <p style={{ fontSize: "9px" }}>
                    {" "}
                    Peak Power input value is max 9999.{" "}
                  </p>
                )}
              />
            </div>
            <Input
              type="number"
              value={specifications?.peakPower?.value}
              onChange={(e) => {
                handleNumberFieldChange(
                  "peakPower",
                  e.target.value,
                  "Peak Power",
                  "engine",
                  5,
                );
              }}
              suffix={
                <div className="fieldPrefix">
                  <p>hp</p>
                </div>
              }
            />
          </div>
        </Col> */}
        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label"> Peak Torque :</p>
              <FieldSuffix
                TooltipData={() => (
                  <p style={{ fontSize: "9px" }}>
                    {" "}
                    Peak Torque input value is max 9999.{" "}
                  </p>
                )}
              />
            </div>
            <Input
              type="number"
              value={specifications?.peakTorque?.value}
              onChange={(e) => {
                handleNumberFieldChange(
                  "peakTorque",
                  e.target.value,
                  "Peak Torque",
                  "engine",
                  5,
                );
              }}
              suffix={
                <div className="fieldPrefix">
                  <p>Nm</p>
                </div>
              }
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label"> Engine Model :</p>
              <FieldSuffix
                TooltipData={() => (
                  <p style={{ fontSize: "9px" }}>
                    {" "}
                    Engine Model input maximum 26 words.{" "}
                  </p>
                )}
              />
            </div>
            <Input
              maxLength={26}
              value={specifications?.engineModel?.value}
              onChange={(text) =>
                handleFieldChange("engineModel", text, "Engine Model", "engine")
              }
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label"> Engine Type :</p>
              <FieldSuffix
                TooltipData={() => (
                  <p style={{ fontSize: "9px" }}>
                    {" "}
                    Engine Type input maximum 26 words.{" "}
                  </p>
                )}
              />
            </div>
            <Input
              maxLength={26}
              value={specifications?.engineType?.value}
              onChange={(text) =>
                handleFieldChange("engineType", text, "Engine Type", "engine")
              }
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label"> Direct Injection :</p>
              <FieldSuffix
                TooltipData={() => (
                  <p style={{ fontSize: "9px" }}>
                    {" "}
                    Direct Injection input maximum 26 words.{" "}
                  </p>
                )}
              />
            </div>
            <Input
              maxLength={26}
              value={specifications?.directInjection?.value}
              onChange={(text) =>
                handleFieldChange(
                  "directInjection",
                  text,
                  "Direct Injection",
                  "engine",
                )
              }
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label"> Aspiration :</p>
              <FieldSuffix
                TooltipData={() => (
                  <p style={{ fontSize: "9px" }}>
                    {" "}
                    Aspiration input maximum 26 words.{" "}
                  </p>
                )}
              />
            </div>
            <Input
              maxLength={26}
              value={specifications?.aspiration?.value}
              onChange={(text) =>
                handleFieldChange("aspiration", text, "Aspiration", "engine")
              }
            />
          </div>
        </Col>
        {/* <Col span={8}>
                    <div className="form-fields">
                    <p className="form-field-label"> Fuel Type : </p>
                    <Select
                        showSearch
                        value={specifications?.fuelType?.value || null}
                        onChange={(value) => handleDropdownChange("fuelType", value, 'Fuel Type', 'engine')}
                        style={{ width: "100%" }}
                        placeholder="Search to Select."
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                        optionA.children
                            .toLowerCase()
                            .localeCompare(optionB.children.toLowerCase())
                        }
                    >
                        {fuelTypes.map((fuel, i) => (
                        <Select.Option key={i} value={fuel}>
                            {fuel}
                        </Select.Option>
                        ))}
                    </Select>
                    </div>
                </Col> */}
      </Row>

      <Divider />

      <div className="sub-header-title">
        <p className="header">PERFORMANCE & ECONOMY</p>
      </div>

      <Row>
        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label">Fuel Consumption :</p>
              <FieldSuffix
                TooltipData={() => (
                  <p style={{ fontSize: "9px" }}>
                    Fuel Consumption input value is max 9999.{" "}
                  </p>
                )}
              />
            </div>
            <Input
              type="number"
              value={specifications?.fuelConsumption?.value}
              onChange={(e) => {
                handleNumberFieldChange(
                  "fuelConsumption",
                  e.target.value,
                  "Fuel Consumption",
                  "performance",
                  5,
                );
              }}
              suffix={
                <div className="fieldPrefix">
                  <p>L/100km</p>
                </div>
              }
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label">CO2 Emission :</p>
              <FieldSuffix
                TooltipData={() => (
                  <p style={{ fontSize: "9px" }}>
                    CO2 Emission input value is max 9999.{" "}
                  </p>
                )}
              />
            </div>
            <Input
              type="number"
              value={specifications?.co2Emission?.value}
              onChange={(e) => {
                handleNumberFieldChange(
                  "co2Emission",
                  e.target.value,
                  "CO2 Emission",
                  "performance",
                  5,
                );
              }}
            />
          </div>
        </Col>
      </Row>

      <Divider />

      <div className="sub-header-title">
        <p className="header">STEERING</p>
      </div>

      <Row>
        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label">Streering Radius :</p>
              <FieldSuffix
                TooltipData={() => (
                  <p style={{ fontSize: "9px" }}>
                    Streering Radius input value is max 9999.{" "}
                  </p>
                )}
              />
            </div>
            <Input
              type="number"
              value={specifications?.streeringRadius?.value}
              onChange={(e) => {
                handleNumberFieldChange(
                  "streeringRadius",
                  e.target.value,
                  "Streering Radius",
                  "steering",
                  5,
                );
              }}
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label">Steering Type :</p>
              <FieldSuffix
                TooltipData={() => (
                  <p style={{ fontSize: "9px" }}>
                    Steering Type input value is maximum 26 words.{" "}
                  </p>
                )}
              />
            </div>
            <Input
              maxLength={26}
              value={specifications?.steeringType?.value}
              onChange={(text) =>
                handleFieldChange(
                  "steeringType",
                  text,
                  "Steering Type",
                  "steering",
                )
              }
            />
          </div>
        </Col>
      </Row>

      <Divider />

      <div className="sub-header-title">
        <p className="header">DIMENSIONS & WEIGHT</p>
      </div>

      <Row>
        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label">Length :</p>
              <FieldSuffix
                TooltipData={() => (
                  <p style={{ fontSize: "9px" }}>
                    Length input value is max 9999.{" "}
                  </p>
                )}
              />
            </div>
            <Input
              type="number"
              value={specifications?.length?.value}
              onChange={(e) => {
                handleNumberFieldChange(
                  "length",
                  e.target.value,
                  "Length",
                  "dimensions",
                  5,
                );
              }}
              suffix={
                <div className="fieldPrefix">
                  <p>mm</p>
                </div>
              }
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label">Width :</p>
              <FieldSuffix
                TooltipData={() => (
                  <p style={{ fontSize: "9px" }}>
                    Width input value is max 9999.{" "}
                  </p>
                )}
              />
            </div>
            <Input
              type="number"
              value={specifications?.width?.value}
              onChange={(e) => {
                handleNumberFieldChange(
                  "width",
                  e.target.value,
                  "Width",
                  "dimensions",
                  5,
                );
              }}
              suffix={
                <div className="fieldPrefix">
                  <p>mm</p>
                </div>
              }
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label">Height :</p>
              <FieldSuffix
                TooltipData={() => (
                  <p style={{ fontSize: "9px" }}>
                    Height input value is max 9999.{" "}
                  </p>
                )}
              />
            </div>
            <Input
              type="number"
              value={specifications?.height?.value}
              onChange={(e) => {
                handleNumberFieldChange(
                  "height",
                  e.target.value,
                  "Height",
                  "dimensions",
                  5,
                );
              }}
              suffix={
                <div className="fieldPrefix">
                  <p>mm</p>
                </div>
              }
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label">Wheel Base :</p>
              <FieldSuffix
                TooltipData={() => (
                  <p style={{ fontSize: "9px" }}>
                    Wheel Base input value is max 9999.{" "}
                  </p>
                )}
              />
            </div>
            <Input
              type="number"
              value={specifications?.wheelBase?.value}
              onChange={(e) => {
                handleNumberFieldChange(
                  "wheelBase",
                  e.target.value,
                  "Wheel Base",
                  "dimensions",
                  5,
                );
              }}
              suffix={
                <div className="fieldPrefix">
                  <p>mm</p>
                </div>
              }
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label">Front Thread :</p>
              <FieldSuffix
                TooltipData={() => (
                  <p style={{ fontSize: "9px" }}>
                    Front Thread input value is max 9999.{" "}
                  </p>
                )}
              />
            </div>
            <Input
              type="number"
              value={specifications?.frontThread?.value}
              onChange={(e) => {
                handleNumberFieldChange(
                  "frontThread",
                  e.target.value,
                  "Front Thread",
                  "dimensions",
                  5,
                );
              }}
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label">Rear Thread :</p>
              <FieldSuffix
                TooltipData={() => (
                  <p style={{ fontSize: "9px" }}>
                    Rear Thread input value is max 9999.{" "}
                  </p>
                )}
              />
            </div>
            <Input
              type="number"
              value={specifications?.rearThread?.value}
              onChange={(e) => {
                handleNumberFieldChange(
                  "rearThread",
                  e.target.value,
                  "Rear Thread",
                  "dimensions",
                  5,
                );
              }}
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label">Kerb Weight :</p>
              <FieldSuffix
                TooltipData={() => (
                  <p style={{ fontSize: "9px" }}>
                    Kerb Weight input value is max 9999.{" "}
                  </p>
                )}
              />
            </div>
            <Input
              type="number"
              value={specifications?.kerbWeight?.value}
              onChange={(e) => {
                handleNumberFieldChange(
                  "kerbWeight",
                  e.target.value,
                  "Kerb Weight",
                  "dimensions",
                  5,
                );
              }}
              suffix={
                <div className="fieldPrefix">
                  <p>kg</p>
                </div>
              }
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label">Fuel Tank :</p>
              <FieldSuffix
                TooltipData={() => (
                  <p style={{ fontSize: "9px" }}>
                    Fuel Tank input value is max 9999.{" "}
                  </p>
                )}
              />
            </div>
            <Input
              type="number"
              value={specifications?.fuelTank?.value}
              onChange={(e) => {
                handleNumberFieldChange(
                  "kerbWeight",
                  e.target.value,
                  "Fuel Tank",
                  "dimensions",
                  5,
                );
              }}
              suffix={
                <div className="fieldPrefix">
                  <p>liters</p>
                </div>
              }
            />
          </div>
        </Col>
      </Row>

      <Divider />

      <div className="sub-header-title">
        <p className="header">BRAKES</p>
      </div>

      <Row>
        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label">Front Brakes :</p>
              <FieldSuffix
                TooltipData={() => (
                  <p style={{ fontSize: "9px" }}>
                    Front Brakes input value is maximum 26 words.{" "}
                  </p>
                )}
              />
            </div>
            <Input
              maxLength={26}
              value={specifications?.frontBrakes?.value}
              onChange={(text) =>
                handleFieldChange("frontBrakes", text, "Front Brakes", "brakes")
              }
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label">Rear Brakes :</p>
              <FieldSuffix
                TooltipData={() => (
                  <p style={{ fontSize: "9px" }}>
                    Rear Brakes input value is maximum 26 words.{" "}
                  </p>
                )}
              />
            </div>
            <Input
              maxLength={26}
              value={specifications?.rearBrakes?.value}
              onChange={(text) =>
                handleFieldChange("rearBrakes", text, "Rear Brakes", "brakes")
              }
            />
          </div>
        </Col>
      </Row>

      <Divider />

      <div className="sub-header-title">
        <p className="header">SUSPENSIONS</p>
      </div>

      <Row>
        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label">Front Suspension :</p>
              <FieldSuffix
                TooltipData={() => (
                  <p style={{ fontSize: "9px" }}>
                    Front Suspension input value is maximum 26 words.{" "}
                  </p>
                )}
              />
            </div>
            <Input
              maxLength={26}
              value={specifications?.frontSuspension?.value}
              onChange={(text) =>
                handleFieldChange(
                  "frontSuspension",
                  text,
                  "Front Suspension",
                  "suspensions",
                )
              }
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label">Rear Suspension :</p>
              <FieldSuffix
                TooltipData={() => (
                  <p style={{ fontSize: "9px" }}>
                    Rear Suspension input value is maximum 26 words.{" "}
                  </p>
                )}
              />
            </div>
            <Input
              maxLength={26}
              value={specifications?.rearSuspension?.value}
              onChange={(text) =>
                handleFieldChange(
                  "rearSuspension",
                  text,
                  "Rear Suspension",
                  "suspensions",
                )
              }
            />
          </div>
        </Col>
      </Row>

      <Divider />

      <div className="sub-header-title">
        <p className="header">TYRES & WHEELS</p>
      </div>

      <Row>
        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label">Front Tyre :</p>
              <FieldSuffix
                TooltipData={() => (
                  <p style={{ fontSize: "9px" }}>
                    Front Tyre input value is maximum 26 words.{" "}
                  </p>
                )}
              />
            </div>
            <Input
              maxLength={26}
              value={specifications?.frontTyre?.value}
              onChange={(text) =>
                handleFieldChange("frontTyre", text, "Front Tyre", "tyres")
              }
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label">Rear Tyre :</p>
              <FieldSuffix
                TooltipData={() => (
                  <p style={{ fontSize: "9px" }}>
                    Rear Tyre input value is maximum 26 words.{" "}
                  </p>
                )}
              />
            </div>
            <Input
              maxLength={26}
              value={specifications?.rearTyre?.value}
              onChange={(text) =>
                handleFieldChange("rearTyre", text, "Rear Tyre", "tyres")
              }
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label">Front Rim :</p>
              <FieldSuffix
                TooltipData={() => (
                  <p style={{ fontSize: "9px" }}>
                    Front Rim input value is maximum 26 words.{" "}
                  </p>
                )}
              />
            </div>
            <Input
              maxLength={26}
              value={specifications?.frontRim?.value}
              onChange={(text) =>
                handleFieldChange("frontRim", text, "Front Rim", "tyres")
              }
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label">Rear Rim :</p>
              <FieldSuffix
                TooltipData={() => (
                  <p style={{ fontSize: "9px" }}>
                    Rear Rim input value is maximum 26 words.{" "}
                  </p>
                )}
              />
            </div>
            <Input
              maxLength={26}
              value={specifications?.rearRim?.value}
              onChange={(text) =>
                handleFieldChange("rearRim", text, "Rear Rim", "tyres")
              }
              suffix={
                <div className="fieldPrefix">
                  <p>inches</p>
                </div>
              }
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Specifications;
